<template>
  <div class="component">
    <nav class="row align-center space-between top-nav">
      <div class="nav-left row align-center">
        <div class="nav-tilte row align-center">
          <div @click="$router.go(0)">
            <img :src="require('../assets/images/logo/' + module + '.png')" alt="logo" height="36px" />
          </div>
        </div>
      </div>
      <div style="margin-left: 20px">
        <slot name="descript"></slot>
      </div>

      <div class="nav-center row align-center space-center">
        <div style="font-size: 20px" v-if="windowId === 'deptCollectMoney'"> 
          <span class="cashier-item" v-if="cashierItem">{{ $t('components.stockTopMenuCashierLabel') }}{{ cashierItem.title }}</span>
          {{ $cache.local.get('deptName') }}/{{ $cache.local.get('deptCode') }}
        </div>
        <div style="font-size: 20px" v-if="curPosition">{{ curPosition }}</div>
      </div>

      <div class="nav-right row align-center space-end">
        <p
          v-if="openDialog && openDialog !== ''"
          @click="openShow"
          class="row align-center"
          style="
            margin-right: 10px;
            background: #eff7ff;
            height: 36px;
            line-height: 36px;
            padding: 0 10px;
            border-radius: 8px;
            cursor: pointer;
          ">
          <span>{{ openDialog }}</span>
        </p>
        <p
          @click="showI18nDialog"
          class="row align-center"
          style="
            margin-right: 10px;
            background: #eff7ff;
            height: 36px;
            line-height: 36px;
            padding: 0 10px;
            border-radius: 8px;
            cursor: pointer;
          ">
          <i class="el-icon-search" style="font-weight: bold; color: #333; margin-right: 5px" :title="$t('components.stockTopMenuTranslante')"></i>
          <span>{{ $t('components.stockTopMenuTranslante') }}</span>
        </p>
        <p
          v-if="1===2"
          @click="lockScreen"
          class="row align-center"
          style="
            margin-right: 10px;
            background: #eff7ff;
            height: 36px;
            line-height: 36px;
            padding: 0 10px;
            border-radius: 8px;
            cursor: pointer;
          ">
          <i class="el-icon-lock" style="font-weight: bold; color: #333; margin-right: 5px" title="锁定"></i>
          <span>{{ $t('components.stockTopMenuLockWithF2') }}</span>
        </p>
        <p
          @click="$common.forceReload()"
          class="row align-center"
          style="
            margin-right: 10px;
            background: #eff7ff;
            height: 36px;
            line-height: 36px;
            padding: 0 10px;
            border-radius: 8px;
            cursor: pointer;
          ">
          <i
            class="el-icon-refresh-left"
            style="font-weight: bold; color: #333; margin-right: 5px"
            :title="$t('components.stockTopMenuRefreshPage')"></i>
          <span>{{ $t('components.stockTopMenuRefreshPage') }}</span>
        </p>
        <div class="min-size cursor nav-right-btn" @click="minWindow">
          <p class="row align-center">
            <i class="el-icon-minus size-icon" title="最小化"></i>
            <span>{{ $t('components.stockTopMenuMinimize') }}</span>
          </p>
        </div>
        <div class="close-size cursor nav-right-btn" @click="closeWindow">
          <p class="row align-center">
            <i class="el-icon-close size-icon" :title="$t('components.stockTopMenuClose')"></i>
            <span>{{ $t('components.stockTopMenuClose') }}</span>
          </p>
        </div>
      </div>
    </nav>
    <I18nKeyMap
      :visible.sync="dialogVisible"
    />
  </div>
</template>

<script>
import { ipcApiRoute, specialIpcRoute } from '@/api/main'
import { ipc } from '@/utils/ipcRenderer'
import Mousetrap from 'mousetrap'
import 'mousetrap/plugins/global-bind/mousetrap-global-bind'
import I18nKeyMap from '@/components/I18nKeyMap.vue'
export default {
  name: 'stockTopMenu',
  components: {
    I18nKeyMap
  },
  props: {
    //组件所属功能模块  默认为stock店铺盘点模块
    module: {
      type: String,
      default: 'stock'
    },
    //当前页面标题
    curPosition: {
      type: String,
      default: ''
    },
    //窗口id
    windowId: {
      type: String,
      default: ''
    },
    //弹窗按钮的名字
    openDialog: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      winFlag: false,
      cashierItem: null,
      dialogVisible: false,
    }
  },
  created() {
    this.cashierItem = JSON.parse(this.$cache.local.get('cashierDeskItem')) || null
    Mousetrap.bind(['f2', 'f2'], () => {
      this.lockScreen()
    })
  },
  methods: {
    showI18nDialog() {
      this.dialogVisible = true
    },
    openShow() {
      this.$emit('openShow')
    },
    lockScreen() {
      ipc.invoke(ipcApiRoute.getWCid, 'main').then(id => {
        let mainWCid = id
        if (mainWCid) {
          ipc.invoke(ipcApiRoute.closeWindowAll).then(r => {})
          ipc.sendTo(mainWCid, specialIpcRoute.window2ToWindow1, 'lockPage')
        }
      })
    },
    minWindow() {
      ipc.invoke(ipcApiRoute.miniWindow, this.windowId).then(r => {})
    },
    closeWindow() {
      this.$confirm(this.$t('components.stockTopMenuCloseConfirm'), {
        title: this.$t('components.stockTopMenuPrompt'),
        message: this.$t('components.stockTopMenuCloseWindowConfirm'),
        confirmButtonText: this.$t('components.stockTopMenuConfirm'),
        cancelButtonText: this.$t('components.stockTopMenuCancel')
      }).then(res => {
        ipc.invoke(ipcApiRoute.closeWindow, this.windowId).then(r => {})
      }).catch(err => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.top-nav {
  height: 60px;
  background: #fff;
  .nav-left {
    -webkit-app-region: no-drag;
    .nav-tilte {
      margin-left: 20px;
      font-size: 14px;
      font-family: 'font-Medium';
      cursor: pointer;
      div {
        font-size: 0;
      }
    }
    .position {
      div {
        background: #067cf2;
        width: 6px;
        height: 30px;
        border-radius: 2px;
        margin-left: 10px;
        margin-right: 20px;
      }
      p {
        font-family: 'font-Regular';
        font-size: 20px;
      }
    }
  }
  .nav-center {
    flex: 1;
    .cashier-item {
      font-size: 14px;
      border: 1px solid #067cf2;
      background: rgb(230, 247, 255);
      border-radius: 4px;
      padding: 2px 4px;
      margin-left: 20px;
    }
  }
  .nav-right {
    -webkit-app-region: no-drag;
    height: 60px;
    .back-icon {
      img {
        width: 36px;
        height: 38px;
        cursor: pointer;
        float: left;
        margin-right: 20px;
      }
    }
    .nav-right-btn {
      margin-right: 10px;
      background: #eff7ff;
      height: 36px;
      line-height: 36px;
      padding: 0 10px;
      border-radius: 8px;
    }
    .size-icon {
      color: #333;
      font-size: 21px;
    }
  }
}
</style>
